const tvrWebUserStats = require('@bbc/tvr-web-user-stats');

module.exports = tvrWebUserStats.default('sounds');
